import { EModalConfirmationTypes } from "interfaces/VetExamState";

const base = "VET_EXAM";
export const SET_IS_EXAM_FORM_OPEN = `${base}_SET_IS_EXAM_FORM_OPEN`;
export const SET_IS_EDIT_PAST_EXAM_FORM_OPEN = `${base}_SET_IS_EDIT_PAST_EXAM_FORM_OPEN`;
export const SET_MODAL_STATE = `${base}_SET_MODAL_STATE`;
export const SET_MODAL_TYPE = `${base}_SET_MODAL_TYPE`;
export const SET_IS_USE_LAST_EXAM_ENTRY = `${base}_SET_IS_USE_LAST_EXAM_ENTRY`;
export const SET_CURRENT_PAST_EXAM_ID = `${base}_SET_CURRENT_PAST_EXAM_ID`;

export interface IVetExamActions {
  type: string;
  isExamFormOpen: boolean;
  isEditPastExamFormOpen: boolean;
  modalState: boolean;
  modalType: EModalConfirmationTypes;
  isUseLastExamEntry: boolean;
  currentPastExamId: string;
}

export const setIsExamFormOpen = (
  isExamFormOpen: boolean
): Pick<IVetExamActions, "type" | "isExamFormOpen"> => ({
  type: SET_IS_EXAM_FORM_OPEN,
  isExamFormOpen
});

export const setIsEditPastExamFormOpen = (
  isEditPastExamFormOpen: boolean
): Pick<IVetExamActions, "type" | "isEditPastExamFormOpen"> => ({
  type: SET_IS_EDIT_PAST_EXAM_FORM_OPEN,
  isEditPastExamFormOpen
});

export const setModalState = (
  modalState: boolean
): Pick<IVetExamActions, "type" | "modalState"> => ({
  type: SET_MODAL_STATE,
  modalState
});

export const setModalType = (
  modalType: EModalConfirmationTypes
): Pick<IVetExamActions, "type" | "modalType"> => ({
  type: SET_MODAL_TYPE,
  modalType
});

export const setIsUseLastExamEntry = (
  isUseLastExamEntry: boolean
): Pick<IVetExamActions, "type" | "isUseLastExamEntry"> => ({
  type: SET_IS_USE_LAST_EXAM_ENTRY,
  isUseLastExamEntry
});

export const setCurrentPastExamId = (
  currentPastExamId: string
): Pick<IVetExamActions, "type" | "currentPastExamId"> => ({
  type: SET_CURRENT_PAST_EXAM_ID,
  currentPastExamId
});
